export type DatePreset = "today" | "yesterday" | "this_week" | "this_month";

interface DateRangeFilterProps {
  preset: DatePreset | null;
  dateFrom: string;
  dateTo: string;
  onChange: (value: {
    preset: DatePreset | null;
    dateFrom: string;
    dateTo: string;
  }) => void;
  onClear: () => void;
}

export const DATE_PRESETS: { value: DatePreset; label: string }[] = [
  { value: "today", label: "Šiandien" },
  { value: "yesterday", label: "Vakar" },
  { value: "this_week", label: "Šią savaitę" },
  { value: "this_month", label: "Šį mėnesį" },
];

export function resolveDatePreset(preset: DatePreset): {
  from: string;
  to: string;
} {
  const today = new Date();
  const fmt = (d: Date) => d.toISOString().split("T")[0];

  switch (preset) {
    case "today":
      return { from: fmt(today), to: fmt(today) };
    case "yesterday": {
      const y = new Date(today);
      y.setDate(y.getDate() - 1);
      return { from: fmt(y), to: fmt(y) };
    }
    case "this_week": {
      const day = today.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(today);
      monday.setDate(today.getDate() - diff);
      return { from: fmt(monday), to: fmt(today) };
    }
    case "this_month": {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      return { from: fmt(first), to: fmt(today) };
    }
  }
}

export function DateRangeFilter({
  preset,
  dateFrom,
  dateTo,
  onChange,
  onClear,
}: DateRangeFilterProps) {
  const hasFilter = preset !== null || dateFrom !== "" || dateTo !== "";

  const handlePreset = (p: DatePreset) => {
    onChange({ preset: p, dateFrom: "", dateTo: "" });
  };

  const handleCustomDate = (field: "dateFrom" | "dateTo", value: string) => {
    onChange({
      preset: null,
      dateFrom: field === "dateFrom" ? value : dateFrom,
      dateTo: field === "dateTo" ? value : dateTo,
    });
  };

  return (
    <div className="w-64">
      <div className="space-y-0.5">
        {DATE_PRESETS.map((p) => (
          <label
            key={p.value}
            className="flex cursor-pointer items-center gap-2 rounded px-1 py-1.5 text-sm text-gray-700 hover:bg-gray-50"
          >
            <input
              type="radio"
              name="date-preset"
              checked={preset === p.value}
              onChange={() => handlePreset(p.value)}
              className="h-3.5 w-3.5 accent-primary-800"
            />
            {p.label}
          </label>
        ))}
      </div>

      <div className="my-2 border-t border-dashed border-gray-200 pt-2">
        <div>
          <label className="mb-1 block text-xs font-medium text-gray-500">
            Nuo
          </label>
          <input
            type="date"
            value={dateFrom}
            onChange={(e) => handleCustomDate("dateFrom", e.target.value)}
            className="input"
          />
        </div>
        <div className="mt-2">
          <label className="mb-1 block text-xs font-medium text-gray-500">
            Iki
          </label>
          <input
            type="date"
            value={dateTo}
            onChange={(e) => handleCustomDate("dateTo", e.target.value)}
            className="input"
          />
        </div>
      </div>

      {hasFilter && (
        <div className="mt-2 border-t border-gray-100 pt-2 text-right">
          <button
            onClick={onClear}
            className="text-xs text-gray-500 hover:text-gray-700"
          >
            Išvalyti
          </button>
        </div>
      )}
    </div>
  );
}
